import type { FC } from "react";

import { Button } from "tw/components/atoms/Button";

export interface InformationBodyProps {
  informationText: string;
  closeSettingsPopup: () => void;
}

export const InformationBody: FC<InformationBodyProps> = ({
  informationText,
  closeSettingsPopup,
}) => {
  return (
    <div className="w-full flex flex-col gap-4 md:pb-4">
      {informationText}
      <Button
        variant="primary"
        label="Got it"
        className="w-full"
        onClick={closeSettingsPopup}
      />
    </div>
  );
};
